import { defineSlotRecipe } from '@chakra-ui/react';
import { radioGroupAnatomy } from '@chakra-ui/react/anatomy';

export const radioGroupRecipe = defineSlotRecipe({
  className: 'ac-radiogroup',
  slots: radioGroupAnatomy.keys(),
  base: {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      alignItems: 'stretch',

      border: 'none',
      padding: '0px',

      _notFirst: {},
    },
    item: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '8px',
    },
    itemControl: {
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      marginRight: '16px',
      backgroundColor: 'grey.light.0',
      border: '1px solid {colors.grey.light.2}',

      transitionDuration: 'faster',
      transitionTimingFunction: 'linear',
      transitionProperty: 'border-color',

      _hover: {
        borderColor: 'grey.light.3',
      },

      '& > .dot': {
        borderRadius: '50%',
        width: '10px',
        height: '10px',
        display: 'inline-block',
        backgroundColor: 'grey.dark.2',
      },
    },
    itemText: {
      color: 'grey.dark.2',
      fontWeight: 400,
      fontSize: '15px',
      lineHeight: '20px',
      letterSpacing: '0.15px',
    },
  },
  variants: {},
});
